import Sidebar from 'components/Sidebar';

export default function Dashboard() {
   
  return (
    <>
        <Sidebar />
    </>
  );
}
